import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminFunctions.css';

const AdminFunctions = ({ functions }) => {
  const navigate = useNavigate();

  // 🌌 Two-tone dark gradient
  const getDarkGradient = () => {
    const hue = Math.floor(Math.random() * 360);
    const color1 = `hsl(${hue}, 40%, 50%)`; // darker shade
    const color2 = `hsl(${hue}, 70%, 30%)`; // slightly lighter shade
    return `linear-gradient(135deg, ${color1}, ${color2})`;
  };

  return (
    <div className="admin-functions-container">
      {functions.map((func, index) => (
        <div
          key={index}
          className="admin-function-box"
          onClick={() => navigate(func.link)}
          style={{ background: getDarkGradient() }}
        >
          <div className="admin-function-iconCircle">
            {/* ✅ If icon starts with `fa-`, render as <i> */}
            {func.icon?.startsWith("fa-") ? (
              <i className={`fas ${func.icon} admin-function-icon`}></i>
            ) : (
              <img src={func.icon} alt={func.name} className="admin-function-icon" />
            )}
          </div>
          <span className="admin-function-text">{func.name}</span>
        </div>
      ))}
    </div>
  );
};

export default AdminFunctions;
